import React from 'react';
import { useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { DataList } from 'commons-ui';

import useDashboardActions from 'pages/dashboard/useDashboardActions';

import { makeActionHandler } from '../../actions/layouts/handlers';
import { makeActionList } from '../../actions/layouts/list';
import { layoutConfig } from './layoutConfig';
import useLayout from './useLayout';

const layout: React.FC<{}> = () => {
	const { getLayoutData, turnGlobalForceUpdateOff, globalForceUpdate, removeLayout } = useLayout();
	const location = useLocation();
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList, {
		versionSupportedConfig: _get(location, ['state', 'rowData']),
		removeLayout
	});

	const actions = getActionList();

	return (
		<div>
			<DataList
				fetchData={getLayoutData}
				globalForceUpdate={globalForceUpdate}
				turnGlobalForceUpdateOff={turnGlobalForceUpdateOff}
				columnConfigs={layoutConfig}
				actions={actions}
				getActionHandler={getActionHandler}
			/>
		</div>
	);
};

export default layout;
